import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateOrderOfCategories = async (placeId, categoryType, positions) => {
  if (!placeId || !categoryType || !positions) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/category/${categoryType}/order`,
    data: { positions },
  });
};